import { useUserBookingsCountListAPI } from "@/app/hooks/api_hooks/bookings/useUserBookingsCountListApi";
import useRouteInfo from "@/app/hooks/useRouteInfo";
import { useRouter } from "@/app/hooks/useRouter";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import {
  AppointmentFilterType,
  ICustomerProfileState,
  setAppointmentFilter,
} from "@/app_redux/reducers/slices/auth/customer_profile_slice";
import clsx from "clsx";
import { startCase } from "lodash";
import { useEffect } from "react";

const FILTER_BUTTONS: Array<{ title: AppointmentFilterType }> = [
  {
    title: "TODAY",
  },
  {
    title: "UPCOMING",
  },
  {
    title: "ALL",
  },
];

const AppointmentStatusButton = () => {
  const { getRouteKey } = useRouter();
  const { routeState } = useRouteInfo(getRouteKey("CUSTOMER_PROFILE", "id"));
  const { customerId, bookingCountList, appointmentFilter } = routeState.state as ICustomerProfileState;

  const fetchBookingListCountAPI = useUserBookingsCountListAPI();
  const dispatch = useAppDispatch();

  useEffect(() => {
    fetchBookingListCountAPI(customerId);
  }, []);

  useEffect(() => {
    if (!bookingCountList) return;
    
    const exotelUpcoming = sessionStorage.getItem("exotel_is_upcoming_appointment");
    if (exotelUpcoming === "true") {
      dispatch(setAppointmentFilter("UPCOMING"));
      return;
    }
    if (exotelUpcoming === "false") {
      dispatch(setAppointmentFilter("ALL"));
      return;
    }

    const today = bookingCountList?.current_date_booking;
    const upcoming = bookingCountList?.upcoming_appointment_booking;

    if (today?.count === 0 && upcoming?.count === 0) {
      dispatch(setAppointmentFilter("ALL"));
    } else if (today?.count >= 1) {
      dispatch(setAppointmentFilter("TODAY"));
    } else if (today?.count === 0 && upcoming?.count >= 1) {
      dispatch(setAppointmentFilter("UPCOMING"));
    } else {
      dispatch(setAppointmentFilter("ALL"));
    }
  }, [bookingCountList]);

  const handleAppointmentFilterSelect = (filterString: AppointmentFilterType) => {
    dispatch(setAppointmentFilter(filterString));
  };

  return (
    <div className="flex items-center gap-4">
      {FILTER_BUTTONS?.map((fl) => {
        return (
          <button
            key={fl.title}
            className={clsx(
              "rounded-2xl  font-medium text-[10px] sm:text-xs  py-1 sm:py-1 2xl:py-2 px-4 sm:px-6 xl:px-8 2xl:px-10  border border-gray-500",
              appointmentFilter === fl.title ? "bg-black text-white" : "bg-white text-black",
            )}
            onClick={() => handleAppointmentFilterSelect(fl.title)}
          >
            {startCase(fl?.title?.toLowerCase())}
          </button>
        );
      })}
    </div>
  );
};

export default AppointmentStatusButton;
